import { render, staticRenderFns } from "./Regional.vue?vue&type=template&id=34f650fe&scoped=true"
import script from "./Regional.vue?vue&type=script&lang=js"
export * from "./Regional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f650fe",
  null
  
)

export default component.exports